require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-راديو-أونلاين.json") })
        }
      }, "path---tags-راديو-أونلاين");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-راديو-أونلاين!./.cache/json/tags-راديو-أونلاين.json
// module id = 608
// module chunks = 231608221292675